import React, { useState, useEffect } from "react";
import Loading from "../../../../common/components/Loading";
import { CGE } from "../../../../common/components/CGE";
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';


function NoLight(props) {

    const [localClient, setLocalClient] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorCli, setErrorCli] = useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });

    let propsLabelInfoContent = {
        "content": props.state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    function handleClick() {
        props.showAlert = false;
        setLoading(true);
        if (!localClient) {
            setErrorCli(true);
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
        } else if(!verifReCaptcha){
            setErrorCli(true);
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
        } else {
            props.funcClick(localClient);
            setErrorCli(false);
        }
    }


  function onChangeReCaptcha(value) {
    updateCookieState(value);
    if (value) {
      setVerifReCaptcha(true);
    }
    else {
      setVerifReCaptcha(false);
    }
  }

    useEffect(() => {
        if (props.state?.idCtaCto) {
            setLoading(false);
        }

    }, [props.state?.estaSinLuz])

    React.useEffect(() => {
        if (props.showAlert) {
            props.setGlobalAlert(props.msgAlert, "warning", true, "Advertencia");
        }
    }, [props.showAlert])

    return (
        <CGE.Panel title="Estás sin luz" description="Revisa aquí el estado de tu suministro eléctrico ingresando tu número de cliente">
            <CGE.PanelContainer
                alingItensCenter={true}
                size="md"
            >
                        <div>
                            <CGE.FormsField
                            handleChange={(e) => setLocalClient(e.target.value)}
                            typeFormElement="text"
                            typeElement="input-mask"
                            maxLength="12"
                            propsLabelInfoContent={propsLabelInfoContent}
                            labelName="Número de Cliente:"
                            mandatoryElement={true}
                            horizontal={true}
                            formatChars={{
                                9: "[0-9]"
                            }}
                            mask="999999999999"
                            placeholder="Ingresar el numero de cliente"
                            hasError={errorCli && !localClient}
                            msgError="Debes ingresar un Nro. de Cliente"
                            />
                        </div>
                    <CGE.Spacing type="md" />
                    <CGE.FieldRecaptcha
                        horizontal={true}
                        onChange={onChangeReCaptcha}
                        sitekey={props.api_key_recaptcha}
                    />
            </CGE.PanelContainer>                    
                    <div class="d-flex flex-column align-items-center">
                        <CGE.Button
                            label="Ingresar"
                            onClick={() => handleClick()}
                            type="primary"
                        />
                        <CGE.Spacing type="ct" />

                        {!errorCli && loading && !props.showAlert && <Loading />}

                        <CGE.Text
                            href="/web/guest/busqueda-cliente?estas-sin-luz=1"
                            text="¿Cuál es mi Número de Cliente?"
                            size="8"
                            style={{ color: '#00a7e1' }}
                        />
                    </div>
        </CGE.Panel>
    );
};

export default NoLight;